module.exports = __webpack_public_path__ + "img/hello-fresh@2x.9aa556a5.png";